import SparkMD5 from 'spark-md5';

/**
 * 计算 ArrayBuffer 的 MD5 哈希值 (32位十六进制小写字符串)
 */
export function calculateArrayBufferMd5(buffer: ArrayBuffer): string {
  return SparkMD5.ArrayBuffer.hash(buffer);
}

/**
 * 计算 Blob/File 对象的 32 位小写 MD5 值
 */
export async function calculateFileMd5(file: Blob): Promise<string> {
  const buffer = await file.arrayBuffer();
  return SparkMD5.ArrayBuffer.hash(buffer);
}
